import { useState } from "react";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { cartsChanged } from "../../../../store/action/cart";
import { setUser } from "../../../../store/action/auth";
import CartService from "../../../../services/cart/Cart";
import { Modal } from "../../../../components/dialog";
import { Warning } from "../../../../components/button";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import { Div, HeaderDetailTitle } from "./style";

const Form = (props) => {
  const { refrence, user, theme, cartsChanged } = props;

  const [state, setState] = useState({
    coupon: "",
  });
  const [isLoadingSendData, setIsLoadingSendData] = useState(false);

  const handleSubmit = () => {
    setIsLoadingSendData(true);

    HttpService(user?.token)
      .post("carts/coupon", {
        coupon_code: state.coupon,
      })
      .then((response) => {
        refrence.current.changeStatus();

        CartService.setCart(response.data?.entity, cartsChanged);

        Http(response?.status, response?.data?.message, props);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingSendData(false);
      });
  };

  const handleChange = (e) => {
    setState({
      ...state,
      coupon: e.target.value,
    });
  };

  return (
    <>
      <Modal ref={refrence}>
        <Div className="p-3 text-right">
          <Div className="mb-4">
            <HeaderDetailTitle theme={theme}>کد تخفیف</HeaderDetailTitle>
            <IconButton
              className="float-left p-0"
              color="inherit"
              onClick={() => refrence.current.changeStatus()}
            >
              <HighlightOffIcon />
            </IconButton>
          </Div>
          <input
            name="coupon"
            placeHolder="کد تخفیف خود را وارد کنید"
            className={`form-control input-default false false false mb-2-5 ${
              theme?.isDarkTheme ? "dark" : ""
            }`}
            onBlur={handleChange}
            autoComplete={false}
          />
          <Warning
            title="بررسی کد"
            containerClass="d-block"
            className="d-block"
            isLoading={isLoadingSendData}
            sizeSpinner={20}
            onClick={handleSubmit}
          />
        </Div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser, cartsChanged })(Form);
